const doc = [({"no":({"js":({"components":({"surveys":({"clone_button":({"clone_survey":" Klone spørreskjema", "the_survey_was_cloned":" Spørreskjemaet ble klonet."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;